import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'PROFILE_MENU';
export const {
    action: fetchLogins,
    success: fetchLoginsSuccess,
    failed: fetchLoginsFailed,
} = createAction(`${domain}/FETCH_LOGINS`, () => ({}));

export const {action: setShowWhatsNewNotificationBadge} = createAction(
    `${domain}/SET_SHOW_WHATS_NEW_NOTIFICATION_BADGE`,
    showWhatsNewNotificationBadge => ({showWhatsNewNotificationBadge}),
);

export const {action: startSentryRecording} = createAction(
    `${domain}/START_SENTRY_RECORDING`,
    (sentryRecordingId: string) => ({sentryRecordingId}),
);

export const {action: stopSentryRecording} = createAction(`${domain}/STOP_SENTRY_RECORDING`, () => ({}));
